import { render, staticRenderFns } from "./CorrectionCreateModal.vue?vue&type=template&id=3fdd3a86&"
import script from "./CorrectionCreateModal.vue?vue&type=script&lang=js&"
export * from "./CorrectionCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports